<script lang="ts">
	import { goto } from '$app/navigation';
	import { page } from '$app/state';
	import { getTeamImageUrl } from '#lib/hockeydata/hockeydata.js';
	import { onMount } from 'svelte';
	import { twMerge } from 'tailwind-merge';

	const { data, params, children } = $props();

	const teams = $derived.by(() => {
		return data.groupTeams
			.filter((team) => team.clubCode !== null)
			.sort((a, b) => {
				if (a.id === data.ownTeamId) {
					return -1;
				} else if (b.id === data.ownTeamId) {
					return 1;
				} else {
					return b.id - a.id;
				}
			});
	});

	onMount(() => {
		if (page.url.pathname.endsWith('teams/') || page.url.pathname.endsWith('teams')) {
			goto(page.url.pathname + '/' + data.ownTeamId);
		}
	});
</script>

<h2 class="mb-3">Teams</h2>
<div class="mb-3 grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6">
	{#each teams as team}
		<a
			href={(params.wildcats ? '/wildcats' : '') +
				`/saison/${params.seasonId}/teams/${team.id}#teamContent`}
			class={twMerge(
				'bg-base-100 shadow-accent/10 flex items-center justify-center bg-size-[auto_90%] bg-left bg-no-repeat px-3 py-3 text-center text-xl font-bold tracking-wider uppercase bg-blend-overlay hover:shadow-xl md:bg-center md:py-10',
				team.id === data.ownTeamId ? 'text-accent' : '',
				page.url.pathname.startsWith(`/saison/${params.seasonId}/teams/${team.id}`)
					? 'border-accent border-b-2'
					: ''
			)}
			style={`background-image: url(${getTeamImageUrl(team.id, data.season.seasonId!!)})`}
		>
			{team.longname}
		</a>
	{/each}
</div>

{@render children()}
